import React, { PropTypes, Component } from 'react';
import {findDOMNode, render, unmountComponentAtNode} from 'react-dom';
import InputElement from '../c_SourceModMaskedInput';
import TextField from '../c_TextField';

const nonAlphaNumericRegex = /[^A-Za-z0-9]/g;

const whiteSpaceRegex = /\s/g;


export default class MaskedTextField extends Component {
  static propTypes = {
    mask: PropTypes.string,
    hideMaskChar: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      React.PropTypes.number
    ]),
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      React.PropTypes.number
    ]),
    onErrorChange: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    validation: PropTypes.object,
    'data-id': PropTypes.string
  }

  state = {
    value: this.props.value || this.props.defaultValue || ''
  }

  componentWillReceiveProps(newProps) {
    if(this.props.value !== newProps.value) {
      this.setState({
        value: newProps.value
      });
    }
  }

  onChange = event => {
    const newVal = event.target.value.replace(nonAlphaNumericRegex, '').replace(whiteSpaceRegex, '');

    // need this to tell masked input that it's populated
    this.setState({
      value: newVal
    });

    if(this.props.onChange) {
      this.props.onChange(event, newVal);
    }
  }

  onFocus = event => {
    if(this.props.onFocus) {
      this.props.onFocus(event, event.target.value.replace(nonAlphaNumericRegex, ''));
    }
  }

  onBlur = event => {
    if(this.props.onBlur) {
      this.props.onBlur(event, event.target.value.replace(nonAlphaNumericRegex, ''));
    }
  }

  checkErrors() {
    if (this.refs['maskedText'].checkErrors) {
      this.refs['maskedText'].checkErrors();
    }
  }

  render() {
    const {
      mask,
      value,
      defaultValue,
      'data-id' : dataId,

      // pull functions off props to replace with modified ones
      onChange, /* eslint no-unused-vars:0 */
      onBlur,   /* eslint no-unused-vars:0 */
      onFocus,  /* eslint no-unused-vars:0 */
      hideMaskChar,
      ...other
    } = this.props;

    return (
      <TextField {...other}
                 proxyVal={this.state.value}
                 onChange={this.onChange}
                 onBlur={this.onBlur}
                 onFocus={this.onFocus}
                 ref="maskedText">
        <InputElement className={`masked-input ${this.state.value ? 'populated' : ''}`}
                      data-id={dataId}
                      value={this.state.value}
                      mask={mask}
                      maskChar={hideMaskChar ? null : ' '} />
      </TextField>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_MaskedTextField/index.js